import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import TestModeBanner from "@/components/layout/TestModeBanner";
import DemoBanner from "@/components/layout/DemoBanner";
import Sidebar from "@/components/layout/Sidebar";
import TopHeader from "@/components/layout/TopHeader";
import { InvoicePreviewProvider } from "@/contexts/InvoicePreviewContext";
import { useOrientation } from "@/hooks/useOrientation";

const MainLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user } = useAuth();
  const demoMode = !!user?.demo_mode;
  // Responsive Orientation Layout (R-UX-LANDSCAPE-001):
  // hook ustawia `data-orientation` na <body>, dzięki czemu globalne style
  // CSS przełączają layout na dwie kolumny w landscape telefonu.
  const { isPhoneLandscape, isPhoneLandscapeWide } = useOrientation();

  // Auto-zamknięcie drawera przy obrocie do landscape — sidebar nie zajmuje
  // kolumny, ale otwarty drawer psułby wykorzystanie szerokości.
  useEffect(() => {
    if ((isPhoneLandscape || isPhoneLandscapeWide) && sidebarOpen) {
      setSidebarOpen(false);
    }
  }, [isPhoneLandscape, isPhoneLandscapeWide, sidebarOpen]);

  return (
    <InvoicePreviewProvider>
      <div className="min-h-screen">
        <DemoBanner visible={demoMode} />
        <TestModeBanner />
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <div className="main-content">
          <TopHeader onMenuClick={() => setSidebarOpen(true)} />
          <main className="page-container animate-fade-in">
            {children}
          </main>
        </div>
      </div>
    </InvoicePreviewProvider>
  );
};

export default MainLayout;
